import { create } from 'axios';
import { store } from 'App';
import { t } from 'helpers/i18n';
import { provider } from 'helpers/Providers';
const UNABLE_CONNECT = t('error:unableConnect');
const TRY_AGAIN_LATER = t('error:tryAgainLater');
const LOGIN_AGAIN = t('error:loginAgain');
export const api = create({
    baseURL: process.env.REACT_APP_SERVER,
    timeout: 20000,
    headers: {
        // TODO: Implement provider detection
        'X-Provider': provider,
        'Access-Control-Allow-Origin': '*',
        'X-Type': 'virtual',
    },
});
api.interceptors.request.use((res) => {
    store.UI.createLoading(res);
    return res;
});
api.interceptors.response.use((res) => {
    store.UI.removeLoading(res.config);
    return res.data;
}, (error) => {
    if (!error.config && !error.response)
        store.UI.removeLoading();
    if (error.response)
        store.UI.removeLoading(error.response.config);
    else
        store.UI.removeLoading(error.config);
    // console.log('Api - interceptors.response - error: ', error)
    if (!error.response) {
        store.UI.newError(UNABLE_CONNECT);
    }
    else if (error.status > 500) {
        store.UI.newError(TRY_AGAIN_LATER);
    }
    else if (error.response.status === 500) {
        store.UI.newError(error.response.data.message);
    }
    else if (error.response.data.statusCode === 401) {
        if (error.config.url.indexOf('logout') < 0) {
            store.UI.newError(LOGIN_AGAIN);
            store.users.logout();
        }
    }
    else {
        // Client error
        console.log('error.response.data: ', error.response.data);
        if (!error.response.data.message) {
            store.UI.newWarning(error.response.data.error);
        }
        else {
            store.UI.newWarning(error.response.data.message);
        }
    }
    throw error;
    return { then: () => { } }; // tslint:disable-line:no-empty
});
export const updateHeaders = (token, client) => {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    api.defaults.headers.common['X-Client'] = client;
};



//////////////////
// WEBPACK FOOTER
// ./src/helpers/Api.ts
// module id = 12
// module chunks = 0